import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'corpCode'
})
export class CorpCodePipe implements PipeTransform {

  transform(corpCode: string, ...args: any[]): any {
    try {
      let originVal = corpCode
      if(corpCode) {
        corpCode = corpCode.replace(/-/gi, "")
      }
      if(corpCode != null) {
          if(corpCode.length == 10) {
            const regex = '^([0-9]{3})([0-9]{2})([0-9]{5})$'
            corpCode = corpCode.match(regex).slice(1, 4).join("-")
          } else {
            corpCode = originVal + '(형식오류)'
          }
      } else {
        corpCode = "미등록"
      }
    } catch (error) {
      console.log(error)
      corpCode = "에러"
    }
    return corpCode;
  }

}
